import { Diagnostic } from './Diagnostic';
export class UsageHit extends Diagnostic {
    constructor(param) {
        super({
            ...param,
            type: 'USAGE'
        });
    }
}
